import React, { useContext, useEffect, useRef, useState } from "react";
import "./AdvanceDashboard.css";
import Header from "../../Header/Header";
import { Link, useNavigate } from "react-router-dom";
import Dashboard_LineChart from "./Dashboard_LineChart/Dashboard_LineChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faCalendarCheck,
  faCartFlatbed,
  faChartSimple,
  faCircleUser,
  faComments,
  faExclamationCircle,
  faGlobe,
  faIndustry,
  faLightbulb,
  faMessage,
  faPhone,
  faRepeat,
  faTape,
  faUpLong,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Card, Button, Form, Row, Col, Table } from "react-bootstrap";
import Rating from "@material-ui/lab/Rating";
import { Context } from "../../../utils/context";
import { faJediOrder } from "@fortawesome/free-brands-svg-icons";
import { RoleId } from "../../../utils/common";
import ProfitLossChart from "./ProfitLossChart/ProfitLossChart";
import { getDownloadDataExcel } from "../../../utils/api";
import RevenueChart from "./RevenueChart/RevenueChart";
import CategoryChart from "./CategoryChart/CategoryChart";

function AdvanceDashboard() {
  const [value, setValue] = useState(2);
  const navigate = useNavigate();
  const { getData, usertype, Select2Data } = useContext(Context);

  const [result, setResult] = useState({});
  const [pieData, setPieData] = useState();
  const [avgRating, setAvgRating] = useState(null);
  const [statusCounts, setStatusCounts] = useState({});
  const [chartData, setChartData] = useState({});
  const [reset, setReset] = useState();
  const [doctor, setDoctor] = useState({});
  const getDataAll = async () => {
    const result = await getData("/admin/dashboard/dashboard-data");
    setStatusCounts(result?.data);
  };
  const getDataDoctor = async () => {
    const result = await getData("/admin/dashboard/doctor-wallet");
    setDoctor(result?.data);
  };

  const getChartData = async () => {
    const result = await getData("/admin/dashboard/sales-chart");
    setChartData(result?.data);
  };



  useEffect(() => {
    getDataAll();
    getChartData();
  }, []);

  const [user, setUser] = useState({});

  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      await setUser(response?.data);
    }
  };

  useEffect(() => {
    GetUser();
    getDataDoctor();
  }, []);

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const options = [
    { label: "Product", value: "Product" },
    { label: "Category", value: "Category" },
  ];
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const [data, setData] = useState([]);
  const [dataCategory, setDataCategory] = useState([]);

  const GetAllProfitLoss = async (selectedOption) => {
    const response = await getData(
      `/admin/dashboard/graph?type=${selectedOption?.value || ""}&to=${
        searchDateTo || ""
      }&from=${searchDateFrom || ""}&category_id=${
        searchCategory?.value || ""
      }&sub_category_id=${searchSubCategory?.value || ""}&product_id=${
        searchProduct?.value || ""
      }`
    );
    if (response?.success) {
      setData(response);
    }
  };

  useEffect(() => {
    GetAllProfitLoss(selectedOption);
  }, [selectedOption,reset,]);

  const handleReset = () => {
    setSelectedOption("");
    setSearchDateTo("");
    setSearchDateFrom("");
    setSearchCategory("");
    setSearchSubCategory("");
    setSearchProduct("");
    GetAllProfitLoss();
    GetAllTotal("");
  };

  const GetAllProfitLosscategory = async (selectedOption) => {
    const response = await getData(
      `/admin/dashboard/graph-category?type=${selectedOption?.value || ""}&to=${
        searchDateTo || ""
      }&from=${searchDateFrom || ""}&category_id=${
        searchCategory?.value || ""
      }&sub_category_id=${searchSubCategory?.value || ""}&product_id=${
        searchProduct?.value || ""
      }`
    );
    if (response?.success) {
      setDataCategory(response);
    }
  };

  useEffect(() => {
    GetAllProfitLosscategory(selectedOption);
  }, [selectedOption]);

  const [dataRevenu, setRevenu] = useState("");
  const GetAllTotal = async () => {
    const response = await getData(
      `/admin/dashboard/total-revanu?to=${searchDateTo || ""}&from=${
        searchDateFrom || ""
      }&category_id=${searchCategory?.value || ""}&sub_category_id=${
        searchSubCategory?.value || ""
      }&product_id=${searchProduct?.value || ""}`
    );

    setRevenu(response);
  };

  useEffect(() => {
    GetAllTotal();
  }, [reset]);

  const HandleDownloadProduct = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        // await DownloadExcel(
        //   // "/download-excel/download-users",
        //   `/download-excel/download-users?term=${search || ""}&mobile=${mobile || ""}&from=${from || ""}&to=${to || ""}`,
        //   "Users List"
        // );
        await getDownloadDataExcel(
          `/admin/products/download?from=${searchDateFrom || ""}&to=${
            searchDateTo || ""
          }?category_id=${searchCategory?.value}?sub_category_id=${
            searchSubCategory?.value
          }product_id=${searchProduct?.value}`,
          null,
          "Product List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const HandleDownloadCategory = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        await getDownloadDataExcel(
          `/admin/products/Product-order-download?from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}`,
          null,
          "category Wise Loss"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [searchCategory, setSearchCategory] = useState("");
  const [searchSubCategory, setSearchSubCategory] = useState("");
  const [searchProduct, setSearchProduct] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const [product, setProduct] = useState([]);
  const GetAllCategory = async () => {
    const response = await getData("/common/masters/all-p-category");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };

  const GetAllSubCategory = async (id) => {
    const response = await getData(`/common/masters/all-p-sub-category/${id}`);
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "p_sub_category_id"));
    }
  };

  const GetAllProduct = async (id) => {
    const response = await getData(`/common/masters/product/${id}`);
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "p_sub_category_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
  }, [reset]);

  return (
    <div>
      <div className="main-advancedashboard">
        <section className="AdvanceDashboard">
          <div className="AdvanceDashboardTabs">
            <Header title={"Dashboard"} link={"/masters/social_links"} />
            <div className=""></div>
          </div>
        </section>

        <div className="Main-Section-Advanced-Dashboard">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                  <div
                    className="row"
                    onClick={() => {
                      user?.Store_Detail?.s_category?.is_restaurant_flow
                        ? navigate("/Foods/:id")
                        : navigate("/products");
                    }}
                  >
                    <div className="col-xl-12 col-lg-12">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Products</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="icon"
                                  icon={faChartSimple}
                                />
                              </div>

                              <div className="text_holder">
                                <p className="text">Total Products</p>
                              </div>
                            </div>

                            <div className="count_holder">
                              <p className="count">
                                {" "}
                                {statusCounts?.total_products}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                  <div
                    className="row"
                    onClick={() => {
                      navigate("/product/product-stock");
                    }}
                  >
                    <div className="col-xl-12 col-lg-12">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Stock</h6>
                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="icon"
                                  icon={faArrowTrendUp}
                                />
                              </div>
                              <div className="text_holder">
                                <p className="text">Product Stock</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3"
                  onClick={() => navigate("/product/ratings/:id")}
                >
                  <div className="bucket-card-holder">
                    <div className="card-heading-holder">
                      <h6>Customer Feedback</h6>
                    </div>

                    <div className="card-number-holder">
                      <div className="icon_holder">
                        <FontAwesomeIcon className="inner_icon" icon={faUser} />
                      </div>

                      <div className="text_holder">
                        <h3 className="count_text">
                          {statusCounts?.total_reviews || 0}
                        </h3>
                        <h3 className="title_text">Total Messages</h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                  <div className="bucket-card-holder">
                    <div className="card-heading-holder">
                      <h6>Total</h6>
                    </div>

                    <div className="card-number-holder">
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          className="inner_icon"
                          icon={faWallet}
                        />
                      </div>

                      <div className="text_holder">
                        <h3 className="count_text">
                          {statusCounts?.todays_total}
                        </h3>
                        <h3 className="title_text">Today's Payment</h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                  <div
                    className="bucket-card-holder"
                    onClick={() => navigate("/customers")}
                  >
                    <div className="card-heading-holder">
                      <h6>Total Customer</h6>
                    </div>

                    <div className="card-number-holder">
                      <div className="icon_holder">
                        <FontAwesomeIcon className="inner_icon" icon={faUser} />
                      </div>

                      <div className="text_holder">
                        <h3 className="count_text">
                          {statusCounts?.TotalCustomer}
                        </h3>
                        <h3 className="title_text">Total Customer</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 col-lg-12 mb-3">
                  <div className="row">
                    <div className="col-xl-12 col-lg-12">
                      <div className="bucket-card-holder">
                        <div className="card-heading-holder">
                          <h6>Sales</h6>
                        </div>
                        <div className="card-number-holder">
                          <h3>{chartData?.total}</h3>
                          <p>This month</p>
                        </div>

                        <div className="card-chart-holder">
                          <Dashboard_LineChart chartData={chartData?.data} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-12 mb-3">
                  <div className="row">
                    <div className="col-xl-12 col-lg-6">
                      <div className="row">
                        <div
                          className="col-xl-12 col-lg-12"
                          onClick={() => navigate("/orders/all-orders")}
                        >
                          <div className="bucket-card-holder">
                            <div className="card-heading-holder">
                              <h6>Today's Orders</h6>
                            </div>

                            <div className="card-number-holder">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="inner_icon"
                                  icon={faCartFlatbed}
                                />
                              </div>

                              <div className="text_holder">
                                <h3 className="count_text">
                                  {statusCounts?.total_Orders}
                                </h3>
                                <h3 className="title_text">Today Count</h3>
                              </div>
                            </div>

                            <div className="card-table-holder">
                              <Table className="mb-0">
                                <tbody>
                                  <tr>
                                    <td>New Orders</td>
                                    <td className="num">
                                      {statusCounts?.Pending_orders}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Processing Orders</td>
                                    <td className="num">
                                      {statusCounts?.Processing_orders}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Scheduled Orders</td>
                                    <td className="num">
                                      {statusCounts?.PickupScheduled_orders}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Shipped Orders</td>
                                    <td className="num">
                                      {statusCounts?.Shipped_orders}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Delivered Orders</td>
                                    <td className="num">
                                      {statusCounts?.Delivered_orders}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Cancelled Orders</td>
                                    <td className="num">
                                      {statusCounts?.Cancelled_orders}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Rejected Orders</td>
                                    <td className="num">
                                      {statusCounts?.Rejected_orders}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-xl-12  mb-3">
                  <div className="row">
                    <div className="col-xl-12 col-lg-6">
                      <div className="row">
                        <div
                          className="col-xl-12 col-lg-12"
                        >
                          <div className="bucket-card-holder">
                            <div className="card-heading-holder">
                              <h6>Profit Loss</h6>
                            </div>

                            <div className="card-number-holder">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  className="inner_icon"
                                  icon={faCartFlatbed}
                                />
                              </div>
                            </div>

                            <div className="fiels_holder">
                              <div className="row">
                                <div className="col-xl-2 col-md-3 mb-3">
                                  <Form.Label>Start Date</Form.Label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="from"
                                    value={searchDateFrom}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const year = value.split("-")[0];

                                      if (year.length === 4 || value === "") {
                                        setSearchDateFrom(value);
                                      }
                                    }}
                                  />
                                </div>
                                <div className="col-xl-2 col-md-3 mb-3">
                                  <Form.Label>End Date</Form.Label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="to"
                                    value={searchDateTo}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const year = value.split("-")[0];

                                      if (year.length === 4 || value === "") {
                                        setSearchDateTo(value);
                                      }
                                    }}
                                  />
                                </div>
                                <div className="col-xl-2 col-md-3 mb-3">
                                  <Form.Label>Seletct Type</Form.Label>

                                  <Select
                                    isSearchable
                                    options={options}
                                    value={selectedOption}
                                    placeholder="Select Option"
                                    onChange={(e) => {
                                      setSelectedOption(e);
                                    }}
                                    classNamePrefix="searchProduct"
                                  />
                                </div>
                              
                                <div className="col-xl-2 col-md-3 mb-3">
                                  <Form.Label>Download Excel</Form.Label>
                                  <div>
                                    <button
                                      className="btn btn-success"
                                      type="button"
                                      onClick={() => {
                                        if (
                                          selectedOption?.value === "Category"
                                        ) {
                                          HandleDownloadCategory();
                                        } else {
                                          HandleDownloadProduct();
                                        }
                                      }}
                                    >
                                      Excel
                                      <FontAwesomeIcon
                                        icon="fa-solid fa-file-lines"
                                        className="ms-2"
                                      />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="card-table-holder">
                              <ProfitLossChart data={data} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="p-4">
                  {/* Top Stats */}
                  <Row className="mb-4">
                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Total GST Collected</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="count_holder">
                                <p className="count">
                                  ₹
                                  {Number(dataRevenu?.totals?.totalGST).toFixed(
                                    2
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Total Cess Collected</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="count_holder">
                                <p className="count">
                                  ₹
                                  {Number(
                                    dataRevenu?.totals?.totalCess
                                  ).toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Total Delivery Charges</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="count_holder">
                                <p className="count">
                                  ₹
                                  {Number(
                                    dataRevenu?.totals?.totalDeliveryCharges
                                  ).toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Total Selling Price</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="count_holder">
                                <p className="count">
                                  ₹
                                  {Number(
                                    dataRevenu?.totals?.totalSellingPrice
                                  ).toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Total Offer Discount</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="count_holder">
                                <p className="count">
                                  ₹
                                  {Number(
                                    dataRevenu?.totals?.total_offer_discount
                                  ).toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Total Coupon Discount</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="count_holder">
                                <p className="count">
                                  ₹
                                  {Number(
                                    dataRevenu?.totals?.total_coupon_discount
                                  ).toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                      <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="second_card_holder">
                          <h6 className="title">Total Convenience Fee</h6>

                          <div className="inner_div">
                            <div className="top_heading">
                              <div className="count_holder">
                                <p className="count">
                                  ₹
                                  {Number(
                                    dataRevenu?.totals?.totalPlatformFee
                                  ).toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Row>

                  {/* Filters */}
                  <div className="mb-4 bucket-card-holder">
                    <div className="card-heading-holder">
                      <h6>Filters</h6>
                    </div>

                    <Row className="g-3 mt-2">
                      <Col xl={3} md={3} sm={4}>
                        <input
                          type="date"
                          className="form-control"
                          placeholder="from"
                          value={searchDateFrom}
                          onChange={(e) => {
                            const value = e.target.value;
                            const year = value.split("-")[0];

                            if (year.length === 4 || value === "") {
                              setSearchDateFrom(value);
                            }
                          }}
                        />
                      </Col>
                      <Col xl={3} md={3} sm={4}>
                        <input
                          type="date"
                          className="form-control"
                          placeholder="to"
                          value={searchDateTo}
                          onChange={(e) => {
                            const value = e.target.value;
                            const year = value.split("-")[0];

                            if (year.length === 4 || value === "") {
                              setSearchDateTo(value);
                            }
                          }}
                        />
                      </Col>

                      <Col xl={3} md={3} sm={4}>
                        <Select
                          isSearchable
                          options={categories}
                          value={searchCategory}
                          placeholder="Select Category"
                          onChange={(e) => {
                            setSearchCategory(e);
                            GetAllProduct(e.value);
                            setSearchProduct("");
                          }}
                        />
                      </Col>
                      {/* <Col xl={3} md={3} sm={4}>
                        <Select
                          isSearchable
                          options={subCategories}
                          value={searchSubCategory}
                          placeholder="Select Sub Category"
                          onChange={(e) => {
                            setSearchSubCategory(e);
                            GetAllProduct(e.value);
                          }}
                        />
                      </Col> */}
                      <Col xl={3} md={3} sm={4}>
                        <Select
                          isSearchable
                          options={product}
                          value={searchProduct}
                          placeholder="Select Product"
                          onChange={(e) => {
                            setSearchProduct(e);
                            // GetAllProduct(e.value);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={12}
                        className="d-flex justify-content-end gap-2 mt-4"
                      >
                        {/* <Button variant="success">Apply Filters</Button>
                        <Button variant="outline-secondary">Reset</Button> */}
                        <Button
                          variant="success"
                          onClick={() => {
                            GetAllProfitLoss();
                            GetAllTotal();
                          }}
                        >
                          Apply Filters
                        </Button>

                        <Button
                          variant="outline-secondary"
                          // onClick={() => {
                          // setSelectedOption("");
                          // setSearchDateTo("");
                          // setSearchDateFrom("");
                          // setSearchCategory("");
                          // setSearchSubCategory("");
                          // setSearchProduct("");
                          // GetAllProfitLoss();
                          //   GetAllTotal("");
                          // }}
                          onClick={() => {
                            setSelectedOption("");
                            setSearchDateTo("");
                            setSearchDateFrom("");
                            setSearchCategory("");
                            setSearchSubCategory("");
                            setSearchProduct("");
                            GetAllProfitLoss();
                            setReset(!reset);
                          }}
                        >
                          Reset
                        </Button>
                      </Col>
                    </Row>
                  </div>

                  {/* Charts */}
                  <Row className="mb-4 bucket-card-holder me-0 ms-0">
                    <Col md={6}>
                      <div className="bucket-card-holder">
                        <div className="card-heading-holder d-flex justify-content-between align-items-center">
                          <h6>Product-wise Profit & Loss</h6>
                          <div>
                            <button
                              className="btn btn-success mb-3"
                              type="button"
                              onClick={() => {
                                if (selectedOption?.value === "Category") {
                                  HandleDownloadCategory();
                                } else {
                                  HandleDownloadProduct();
                                }
                              }}
                            >
                              Excel
                              <FontAwesomeIcon
                                icon="fa-solid fa-file-lines"
                                className="ms-2"
                              />
                            </button>
                          </div>
                        </div>
                        <Table striped bordered hover responsive>
                          <thead>
                            <tr>
                              <th>Product</th>
                              <th>Profit</th>
                              <th>Loss</th>
                               <th>Total Order</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.data?.productData?.map((val) => (
                              <tr>
                                <td>{val?.name}</td>
                                <td>{Number(val?.profit).toFixed(2)}</td>
                                <td>{Number(val?.loss).toFixed(2)}</td>
                                 <td>{Number(val?.totalOrders).toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      {/* <RevenueChart data={data?.data?.productData} /> */}
                    </Col>
                    <Col md={6}>
                      <CategoryChart data={dataCategory?.data?.categoryData} />
                    </Col>
                  </Row>

                  {/* Top Products */}
                  {/* */}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="row">
                    {/* <div className="col-xl-6 col-lg-6">
                      <div className="bucket-card-holder new_card_holder">
                        <div className="card-heading-holder">
                          <h6>Featured Offers %</h6>
                        </div>
                        


                        <div className="featured-card-number-holder">

                          <h3 className="align-items-center title_h3">
                            <div className="icon_holder">
                              <FontAwesomeIcon className="inner_icon" icon={faArrowTrendDown} />
                            </div>
                            {result?.total_amount}
                          </h3>



                          <div className="text_holder">
                            <h3 className="count_text">

                            </h3>
                            <h3 className="title_text">Two days agot</h3>
                          </div>

                        </div>




                        <div className="card-chart-holder"></div>
                      </div>
                    </div> */}

                    {/* <div className="col-xl-6 col-lg-6">
                        <div
                          className="bucket-card-holder new_card_holder"
                          onClick={() => navigate("/product/ratings/:id")}
                        >
                          <div className="card-heading-holder">
                            <h6>Feedback</h6>
                          </div>

                          <div className="card-rating-holder">
                            <h3 className="align-items-center title_h3">
                              <div className="start-rating-holder ">
                                <Rating
                                  name="simple-controlled"
                                  value={avgRating}
                                  precision={0.5}
                                  disabled
                                />
                              </div>
                              {result?.total_rating}{" "}
                            </h3>
                            <p className="text">This Year</p>
                          </div>

                        

                          <div className="card-chart-holder"></div>
                        </div>
                      </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdvanceDashboard;
